$(function () {
    $('#tab-01').on('click', function () {
        var actived = document.querySelector('#tab-01').classList.contains('active');
        if (actived) {
            $(this).removeClass('active');
            $('.content-01').slideUp();

            $('#tab-02').removeClass('opacity-3');
            $('#tab-03').removeClass('opacity-3');
            $('#tab-04').removeClass('opacity-3');
        } else {
            $('.content-tabs-item').removeClass('active');
            $('.content-tabs-item').removeClass('opacity-3');

            $('#tab-02').addClass('opacity-3');
            $('#tab-03').addClass('opacity-3');
            $('#tab-04').addClass('opacity-3');

            if ($(window).width() >= 992) {
                $('.content-02').slideUp();
                $('.content-03').slideUp();
                $('.content-04').slideUp();
            } else {
                $('.content-02').hide();
                $('.content-03').hide();
                $('.content-04').hide();

                $('html,body').animate({
                    scrollTop: $('#tab-01').offset().top - 70
                }, 0);
            }
            
            $(this).addClass('active');
            $('.content-01').slideDown();

            $.get("/get-chart-data", function (data) {
                var date = new Date();
                var years = date.getFullYear();
                var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
                var id = years.toString() + month.toString();
                
                var insurtech = data.insurtech;
                var selected = insurtech.filter((item, index) => {
                    return item.id == id;
                })[0];

                $('.lastMonth-01-value').html(number_format(selected.lastMonth, 0, ',', '.'));
                $('.thisYear-01-value').html(number_format(selected.thisYear, 0, ',', '.'));
                $('.lastYear-01-value').html(number_format(selected.lastYear, 0, ',', '.'));
                
                var initChars = {
                    years: [(years - 1), years],
                    data: {
                        lastYear: selected.lastYear,
                        thisYear: selected.thisYear,
                        lastMonth: selected.lastMonth
                    }
                };
                HighCircleChartGenerate2({
                    ...initChars,
                    elementId: 'chart-01',
                });
                HighCircleChartGenerate2({
                    ...initChars,
                    elementId: 'chart-01-mobile',
                });
            });
        }
    });

    $('#tab-02').on('click', function () {
        var actived = document.querySelector('#tab-02').classList.contains('active');
        if (actived) {
            $(this).removeClass('active');
            $('.content-02').slideUp();

            $('#tab-01').removeClass('opacity-3');
            $('#tab-03').removeClass('opacity-3');
            $('#tab-04').removeClass('opacity-3');
        } else {
            $('.content-tabs-item').removeClass('active');
            $('.content-tabs-item').removeClass('opacity-3');

            $('#tab-01').addClass('opacity-3');
            $('#tab-03').addClass('opacity-3');
            $('#tab-04').addClass('opacity-3');

            if ($(window).width() >= 992) {
                $('.content-01').slideUp(0);
                $('.content-03').slideUp(0);
                $('.content-04').slideUp(0);
            } else {
                $('.content-01').hide(0);
                $('.content-03').hide(0);
                $('.content-04').hide(0);

                $('html,body').animate({
                    scrollTop: $('#tab-02').offset().top - 70
                }, 0);
            }

            $(this).addClass('active');
            $('.content-02').slideDown();

            var locale = $('html').attr('lang');
            var month = new Date().getMonth() > 0 ? (new Date().getMonth() - 1) : 11;
            var month_name = get_month_locale(locale, month)

            $.get("/get-chart-data", function (data) {
                var date = new Date();
                var years = date.getFullYear();
                var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
                var id = years.toString() + month.toString();

                var insurtech = data.ecommerce;
                var selected = insurtech.filter((item, index) => {
                    return item.id == id;
                })[0];

                $('.lastMonth-02-value').html(selected.lastMonth);
                $('.thisYear-02-value').html(selected.thisYear);
                $('.lastYear-02-value').html(selected.lastYear);
                
                var initChars = {
                    elementId: 'chart-02',
                    years: [`<div id="label-bar-chart"><span class="label first-label">${new Date().getFullYear() - 1}</span><span class="label last-label">${new Date().getFullYear()}</span><span class="label last-label">${month_name}</span></div>`],
                    data: {
                        thisYear: selected.thisYear,
                        lastMonth: selected.lastMonth,
                        lastYear: selected.lastYear,
                    }
                };
                HighBarChartGenerate2(initChars);
            });
        }
    });

    $('#tab-03').on('click', function () {
        var actived = document.querySelector('#tab-03').classList.contains('active');
        if (actived) {
            $(this).removeClass('active');
            $('.content-03').slideUp();

            $('#tab-01').removeClass('opacity-3');
            $('#tab-02').removeClass('opacity-3');
            $('#tab-04').removeClass('opacity-3');
        } else {
            $('.content-tabs-item').removeClass('active');
            $('.content-tabs-item').removeClass('opacity-3');

            $('#tab-01').addClass('opacity-3');
            $('#tab-02').addClass('opacity-3');
            $('#tab-04').addClass('opacity-3');

            if ($(window).width() >= 992) {
                $('.content-01').slideUp();
                $('.content-02').slideUp();
                $('.content-04').slideUp();
            } else {
                $('.content-01').hide();
                $('.content-02').hide();
                $('.content-04').hide();

                $('html,body').animate({
                    scrollTop: $('#tab-03').offset().top - 70
                }, 50);
            }

            $(this).addClass('active');
            $('.content-03').slideDown();
        }
    });

    $('#tab-04').on('click', function () {
        var actived = document.querySelector('#tab-04').classList.contains('active');
        if (actived) {
            $(this).removeClass('active');
            $('.content-04').slideUp();

            $('#tab-01').removeClass('opacity-3');
            $('#tab-02').removeClass('opacity-3');
            $('#tab-03').removeClass('opacity-3');
        } else {
            $('.content-tabs-item').removeClass('active');
            $('.content-tabs-item').removeClass('opacity-3');

            $('#tab-01').addClass('opacity-3');
            $('#tab-02').addClass('opacity-3');
            $('#tab-03').addClass('opacity-3');

            if ($(window).width() >= 992) {
                $('.content-01').slideUp();
                $('.content-02').slideUp();
                $('.content-03').slideUp();
            } else {
                $('.content-01').hide();
                $('.content-02').hide();
                $('.content-03').hide();

                $('html,body').animate({
                    scrollTop: $('#tab-04').offset().top - 70
                }, 0);
            }

            $(this).addClass('active');
            $('.content-04').slideDown();
        }
    });
});

function number_format(number, decimals, decPoint, thousandsSep) { 
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''

    var toFixedFix = function (n, prec) {
    var k = Math.pow(10, prec)
    return '' + (Math.round(n * k) / k)
        .toFixed(prec)
    }

    // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
    if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
    }

    return s.join(dec)
}

function get_month_locale(locale, month) {
    var result = null

    switch (locale) {
        case 'id':
            
            switch (month) {
                case 0:
                    result = 'Jan.';
                    break;
                case 1:
                    result = 'Feb.';
                    break;
                case 2:
                    result = 'Mar.';
                    break;
                case 3:
                    result = 'Apr.';
                    break;
                case 4:
                    result = 'Mei';
                    break;
                case 5:
                    result = 'Jun.';
                    break;
                case 6:
                    result = 'Jul.';
                    break;
                case 7:
                    result = 'Ags.';
                    break;
                case 8:
                    result = 'Sep.';
                    break;
                case 9:
                    result = 'Okt.';
                    break;
                case 10:
                    result = 'Nov.';
                    break;
                case 11:
                    result = 'Des.';
                    break;
            }
            
            break;
        case 'de':

            switch (month) {
                case 0:
                    result = 'Jan.';
                    break;
                case 1:
                    result = 'Feb.';
                    break;
                case 2:
                    result = 'Mär.';
                    break;
                case 3:
                    result = 'Apr.';
                    break;
                case 4:
                    result = 'Mai';
                    break;
                case 5:
                    result = 'Jun.';
                    break;
                case 6:
                    result = 'Jul.';
                    break;
                case 7:
                    result = 'Aug.';
                    break;
                case 8:
                    result = 'Sep.';
                    break;
                case 9:
                    result = 'Okt.';
                    break;
                case 10:
                    result = 'Nov.';
                    break;
                case 11:
                    result = 'Dez.';
                    break;
            }

            break;
        default:

            switch (month) {
                case 0:
                    result = 'Jan.';
                    break;
                case 1:
                    result = 'Feb.';
                    break;
                case 2:
                    result = 'Mar.';
                    break;
                case 3:
                    result = 'Apr.';
                    break;
                case 4:
                    result = 'May.';
                    break;
                case 5:
                    result = 'Jun.';
                    break;
                case 6:
                    result = 'Jul.';
                    break;
                case 7:
                    result = 'Aug.';
                    break;
                case 8:
                    result = 'Sep.';
                    break;
                case 9:
                    result = 'Oct.';
                    break;
                case 10:
                    result = 'Nov.';
                    break;
                case 11:
                    result = 'Dec.';
                    break;
            }
            break;
    }

    return result;
}